module.exports = {
  domain: {
    desktop: "ia.stg.use2.racing.fndlext.net",
    mobile: "ia.stg.use2.racing.fndlext.net",
    talentPicks: "ia.stg.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.tvg.com"
  },
  recaptchaID: "6LeIYBcqAAAAAE2wDhSub9Ic8oeidAiiUt4gYM4a",
  recaptchaIdNative: "6LfRQloqAAAAABY9v2RydlB10Lfgb5ODmvygHy3G"
};
